export const userStorage = 'spitasUser';
